import {useEffect, useState, useRef} from 'react';
import styled from 'styled-components';
import Bricks from '../assets/images/bricks-pattern.svg';
import {playSession} from '../utils/api';
import Modal from './Modal';
import {useTranslation} from 'react-i18next';

interface PlayerProps {
  sessionToken: string;
  setGameStatus: Function;
}

export default function Player({setGameStatus, sessionToken}: PlayerProps) {
  const [showModal, setShowModal] = useState(true);
  const [assetUrl, setAssetUrl] = useState('');
  const [istructions, setIstructions] = useState<GameIstructionsT>({
    it: '',
    en: '',
    es: '',
    pl: '',
  });
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const APIurl = process.env.REACT_APP_BASE_URL || '';
  const {t, i18n} = useTranslation();

  const langUser = i18n.language as LangUserT;

  useEffect(() => {
    const fetchGame = async () => {
      try {
        const response = await playSession(sessionToken);
        const lang = response.language;
        setAssetUrl(response.project.game.assetUrl);
        setIstructions({
          it: response.project.game.instructionsIt,
          en: response.project.game.instructionsEn,
          es: response.project.game.instructionsEs,
          pl: response.project.game.instructionsPl,
        });

        if (iframeRef.current) {
          iframeRef.current.addEventListener('load', () => {
            // @ts-expect-error
            iframeRef.current.contentWindow.onComplete = () => {
              setGameStatus('completed');
            };
            // @ts-expect-error
            iframeRef.current.contentWindow.OnGameReady = () => {
              // @ts-expect-error
              iframeRef.current.contentWindow.setGameData(
                sessionToken,
                APIurl,
                lang
              );
            };
          });
        }
      } catch (err) {
        console.log(err);

        setIstructions({
          it: t('game.istructions.generic-error'),
          en: t('game.istructions.generic-error'),
          es: t('game.istructions.generic-error'),
          pl: t('game.istructions.generic-error'),
        });
      }
    };

    fetchGame();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionToken]);

  return (
    <>
      <PlayerContainer>
        <PlayerInner>
          <FrameContainer>
            <FrameWrapper>
              <Frame>
                <iframe
                  ref={iframeRef}
                  title="game"
                  src={assetUrl}
                  width={100}
                  height={100}
                ></iframe>
              </Frame>
            </FrameWrapper>
          </FrameContainer>
        </PlayerInner>
      </PlayerContainer>

      {showModal && (
        <Modal closeModal={() => setShowModal(false)}>
          <Advice>{t('game.istructions.advice')}</Advice>
          {istructions[langUser] && (
            <div
              dangerouslySetInnerHTML={{__html: istructions[langUser]}}
            ></div>
          )}
        </Modal>
      )}
    </>
  );
}

const PlayerContainer = styled.div`
  width: 100%;
`;

const PlayerInner = styled.div`
  background-image: url(${Bricks});
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  width: 100%;
`;

const FrameContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
`;

const FrameWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  background-color: gray;
  width: 100%;
  height: 0;
  padding-top: 56.25%;
  border-radius: 10px;
  overflow: hidden;
`;

const Frame = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  border-radius: 10px;
  overflow: hidden;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const Advice = styled.p`
  margin-bottom: 2rem;
  padding: 0.8rem 1rem;
  border: solid 1px ${(props) => props.theme.colors.orange500};
  background-color: ${(props) => props.theme.colors.orange100};
  color: ${(props) => props.theme.colors.orange600};
  font-size: 1rem;
`;
